import Vue from 'vue'
import Router from 'vue-router'
import index from '@/App'
import layout from "@/view/layout";
import orders from '@/view/order/index.vue'
import zipCode from "@/view/zipCode/index.vue"
import pricing from "@/view/pricing/index.vue"
import drivers from "@/view/driver/index.vue"
import customers from "@/view/customers/index.vue"
import coupons from "@/view/Coupons/index.vue"
import  ads from "@/view/Ads/index.vue"
import redemption from "@/view/redemption/index.vue"
import wage from "@/view/wageReview/wage.vue"
import login from "@/view/login.vue"




Vue.use(Router)
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}


Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/orders",
      hidden: true,
    },
    {
      path: "/login",
      component: login,
      name: "login",
      hidden: true,
    },
    {
      path: "",
      component: layout,
      children: [
        {
          path: '/',
          redirect:'/orders',
          name: '',
          component: index,
        },

        {
          path:'/orders',
          name:'orders',
          component:orders,
          meta:{
            title:'Orders'
          }
        },
        // {
        //   // login
        //   path:'/login',
        //   name:'login',
        //   component:login,
        //   meta:{
        //     title:'login'
        //   }
        // },

        {
          path:'/zipCode',
          name:'zipCode',
          component:zipCode,
          meta:{
            title:'Zip code & Area'
          }
        },
        {
          path:'/pricing',
          name:'pricing',
          component:pricing,
          meta:{
            title:'pricing'
          }
        },

        {
          path:'/drivers',
          name:'drivers',
          component:drivers,
          meta:{
            title:'drivers'
          }
        },
        {
          path:'/customers',
          name:'customers',
          component:customers,
          meta:{
            title:'customers'
          }
        },
        {
          path:'/coupons',
          name:'coupons',
          component:coupons,
          meta:{
            title:'coupons'
          }
        },

        {
          path:'/ads',
          name:'ads',
          component:ads,
          meta:{
            title:'ads'
          }
        },
        {
          path:'/redemption',
          name:'redemption',
          component:redemption,
          meta:{
            title:'redemption'
          }
        },
        {
          path:'/wage',
          name:'wage',
          component:wage,
          meta:{
            title:'Earnings Review'
          }
        },
      ],
    },
    ],
})


